export default __webpack_public_path__ + "static/bead-b45f8e3af4cdee0ac9798332f070062d.png";